import { Component } from '@angular/core';
import { DatepickerComponent } from '../../../utils/datepicker/datepicker.component';
import { CustomTableComponent } from '../../../utils/custom-table/custom-table.component';
import { LoaderComponent } from '../../../utils/loader/loader.component';
import { ReportsServicesService } from '../../../services/reports-services.service';
import { DevicesService } from '../../../services/devices.service';
import { Device } from '../../../models/device';
import { TicketComponent } from '../../../utils/ticket/ticket.component';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { PaginatorComponent } from "../../../utils/paginator/paginator.component";
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { environment } from '../../../../environments/environment';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';

import { ImageModule } from 'primeng/image';
import { ToastService } from '../../../services/toast.service';



export enum ViewType {
  table,
  ticket
}
@Component({
    selector: 'app-consumptions',
    imports: [DatepickerComponent, CustomTableComponent, LoaderComponent, FormsModule, TicketComponent, SelectButtonModule, SelectModule, NgxMaskDirective, NgxPaginationModule, PaginatorComponent, CommonModule, ButtonModule, ImageModule, InputTextModule, DialogModule, TooltipModule],
    templateUrl: './consumptions.component.html',
    styleUrl: './consumptions.component.scss',
    providers: [provideNgxMask()]
})
export class ConsumptionsComponent {
  enum: typeof ViewType = ViewType;
  viewType = ViewType.table;
  showAdvancedFilters = false;
  viewOptions = [
    { label: 'Tabla', value: 0 },
    { label: 'Tickets', value: 1 }
  ];
  data: any;
  folioFactura = ''
  reporterURL = environment.wrUrl;
  tokenAuth: any;
  fromDate!: Date;
  toDate!: Date;
  photos: any[] = []
  showModalContent = false;
  loadingContent = false;
  isSignature = false;
  fromDateRequest!: Date;
  toDateRequest!: Date;

  loading = false;
  fromCard = -1;
  toCard = -1;
  invoiceSearch = "";
  selectedStation = -1;
  consumptions: any[] = [];
  signature = "";
  redcoData: string = '';
  isRedcoClient: boolean = false;
  openNotification: boolean = false
  notification: any
  consumptionsButtons: any[] = [{
    text: 'Fotocarga',
    action: (event: any) => this.viewPhotoConsumption(event),
    icon: undefined,
    color: '',
    hasIcon: false,
    showText: true,
  },
  {
    text: 'Firma',
    action: (event: any) => this.viewSignatureConsumption(event),
    icon: undefined,
    color: '',
    hasIcon: false,
    showText: true,
  }];
  allDevices: Device[] = [];

  downloadOptions = [{
    value: 1,
    text: 'XLS',
    action: (event: any) => this.generateReportConsumptions(),
  }, {
    value: 2,
    text: 'PDF',
    action: (event: any) => this.generateReportConsumptions(),
  },
  {
    value: 4,
    text: 'Departamento(PDF)',
    action: (event: any) => this.generateReportConsumptions(),
  },
  {
    value: 5,
    text: 'Departamento Lineal(PDF)',
    action: (event: any) => this.generateReportConsumptions(),
  },

  {
    value: 3,
    text: 'DOC',
    action: (event: any) => this.generateReportConsumptions(),
  },
  {
    value: 6,
    text: 'Departamento(DOC)',
    action: (event: any) => this.generateReportConsumptions(),
  },
  {
    value: 7,
    text: 'Departamento Lineal(DOC)',
    action: (event: any) => this.generateReportConsumptions(),
  }
  ]

  public pagTickets: PaginationInstance = {
    id: 'idPag',
    itemsPerPage: 8,
    currentPage: 1
  };

  viewTypes = [{
    value: ViewType.table,
    text: 'Tabla'
  }, {
    value: ViewType.ticket,
    text: 'Tickets'
  }];
  fromDevices = [
    {
      value: -1,
      text: 'Todas'
    }
  ];
  toDevices = [
    {
      value: -1,
      text: 'Todas'
    }
  ];
  stations = [
    {
      value: -1,
      text: 'Todas'
    }];

  headers: any[] = [
    { key: "date", textHeader: "Fecha", visible: true, type: "date" },
    { key: "consumptionId", textHeader: "No. Ticket", visible: true, type: "string" },
    { key: "card", textHeader: "No. Tarjeta", visible: true, type: "string" },
    { key: "plates", textHeader: "Placas", visible: true, type: "string" },
    { key: "description", textHeader: "Vehículo", visible: true, type: "string" },
    { key: "department", textHeader: "Departamento", visible: true, type: "string" },
    { key: "economicNumber", textHeader: "No. Económico", visible: true, type: "string" },
    { key: "stationCommercialName", textHeader: "Estación", visible: true, type: "string" },
    { key: "pump", textHeader: "Bomba", visible: true, type: "string" },
  
    { key: "quantity", textHeader: "Litros cargados", visible: true, type: "string" },
    { key: "requestedQuantity", textHeader: "Cantidad solicitada", visible: true, type: "string" },
    
    { key: "productDescription", textHeader: "Producto", visible: true, type: "string" },
    { key: "kms", textHeader: "Kilometraje", visible: true, type: "string" },
    { key: "performance", textHeader: "Rendimiento en Lts", visible: true, type: "string" },
    { key: "OperatorNumber", textHeader: "No. de Operador", visible: true, type: "string" },
    { key: "subtotal", textHeader: "SubTotal", visible: true, type: "currency" },
    { key: "tax", textHeader: "IVA", visible: true, type: "currency" },
    { key: "ieps", textHeader: "IEPS", visible: true, type: "currency" },
    { key: "amount", textHeader: "Importe", visible: true, type: "currency" },
    { key: "invoiceId", textHeader: "Factura", visible: true, type: "factura" },
    { key: "folio", textHeader: "Folio QR", visible: true, type: "string" },
    { key: "desc", textHeader: "Descripción", visible: true, type: "string" },
    { key: "comments", textHeader: "Comentario", visible: true, type: "string" },
    { key: "reference", textHeader: "Referencia", visible: true, type: "string" }
    


  ];


  constructor(private service: ReportsServicesService, private deviceService: DevicesService,
    private toastSrv: ToastService, private titleService: Title, private themeService: ThemeService

  ) {
    this.titleService.setTitle("Reporte - Consumos");
    this.themeService.setTitle("Reporte de Consumos");
    this.data = JSON.parse(localStorage.getItem('data')!);

  }

  ngOnInit() {
    this.isRedcoClient = this.data.IsredcoClient.toLowerCase() === 'true';
    this.getStations();
    this.getAllCards();
    // Rango por defecto: últimos 7 días
    this.toDate = new Date();
    this.fromDate = new Date();
    this.fromDate.setDate(this.fromDate.getDate() - 7);
    this.getConsumptions();
  }
  setDatesOnFilter(event: any) {
    this.fromDate = event.from;
    this.toDate = event.to;
  }

  getConsumptions() {
    this.loading = true;
    this.fromDateRequest = new Date(this.fromDate);
    this.toDateRequest = new Date(this.toDate);
    this.pagTickets.currentPage = 1;
    this.service.getConsumptions(this.data.Client_id, this.fromDateRequest, this.toDateRequest, this.fromCard, this.toCard, 1, 30, this.selectedStation, this.redcoData == '' ? 0 : +this.redcoData, this.folioFactura == '' ? 0 : +this.folioFactura).subscribe({
      next: (resp: any) => {
        this.consumptions = resp;
        this.loading = false;
      },
      error: (err: any) => {
        this.consumptions = [];
        this.loading = false;
      }
    });
  }

  getStations() {

    this.service.getStations(null).subscribe({
      next: (resp: any) => {

        resp.forEach((element: any) => {
          this.stations.push({
            value: element.number,
            text: element.commercialName
          })
        });
      },
      error: (err: any) => {
        this.stations = [];
      }

    })

  }

  chanegViewType(event: any) {
    this.viewType = event.value
  }

  changeStation(event: any) {
    this.selectedStation = event.value;
  }


  changeDeviceFilter(event: any, isFromCard: boolean) {
    const val = event?.value ?? event;
    if (isFromCard) {
      this.fromCard = val;
      this.toDevices = [];
      if (this.fromCard != -1) {

        let filtered = this.allDevices.filter((e: any) => e.cardId >= event.value);
        filtered.forEach(element => {
          this.toDevices.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          })
        });
        this.toCard = event.value;
      } else {
        this.toDevices = [
          {
            value: -1,
            text: 'Todas'
          }
        ];
        this.allDevices.forEach(element => {
          this.toDevices.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          })
        });

        this.toCard = -1;

      }



    } else {
      this.toCard = event.value;
    }
  }

  getAllCards() {

    this.deviceService.loadDevices(this.data.Client_number, this.data.User_id, '', true).subscribe({
      next: (resp: any) => {
        this.allDevices = resp;

        resp.forEach((element: any) => {

          this.fromDevices.push({
            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description
          });
          this.toDevices.push({

            value: element.cardId,
            text: (element.cardId.toString().padStart(5, "0")) + ' - ' + element.description

          });
        });

      },
      error: (error: any) => {
        this.allDevices = [];
        this.fromDevices = [];
        this.toDevices = [];
      }

    })
  }

  getPhotoLabel(photoType: number): string {
    const labels: Record<number, string> = { 1: 'Placas', 2: 'Odómetro', 3: 'Licencia', 4: 'No. Económico', 5: 'Operador', 6: 'Evidencia' };
    return labels[photoType] || 'Foto ' + photoType;
  }

  openInTab(image: string) {
    if (image && image != '') {
      let imageTab = new Image();
      imageTab.src = "data:image/png;base64," + image;
      let w = window.open("");
      w!.document.write(imageTab.outerHTML);
    }
  }

  viewPhotoConsumption(consumption: any) {
    this.isSignature = false;
    this.photos = [];
    this.loadingContent = true;
    this.showModalContent = true;
    this.service.getConsumptionPhotos(this.data.Client_number, consumption.secuence).subscribe({
      next: (resp: any) => {
        this.loadingContent = false;
        this.photos = resp;
        if (this.photos.length === 0) {
          this.showModalContent = false;
          this.toastSrv.add({ type: 'info', message: 'No hay fotocargas por mostrar' });
        }
      },
      error: () => {
        this.loadingContent = false;
        this.showModalContent = false;
        this.photos = [];
        this.toastSrv.add({ type: 'error', message: 'Error al cargar fotocargas' });
      }
    });
  }

  viewSignatureConsumption(consumption: any) {
    this.isSignature = true;
    this.signature = '';
    this.loadingContent = true;
    this.showModalContent = true;
    this.service.getConsumptionSignature(this.data.Client_id, consumption.secuence).subscribe({
      next: (resp: any) => {
        this.loadingContent = false;
        this.signature = resp;
      },
      error: () => {
        this.loadingContent = false;
        this.signature = '';
        this.toastSrv.add({ type: 'error', message: 'Error al cargar firma' });
      }
    });
  }

  download(id: string) {

    let url = ''
    let fromDateString = (this.fromDateRequest.getMonth() + 1).toString().padStart(2, "0").substring(0, 2) + '/' + (this.fromDateRequest.getDate().toString().padStart(2, "0")).substring(0, 2) + '/' + this.fromDateRequest.getFullYear()
    let toDateString = (this.toDateRequest.getMonth() + 1).toString().padStart(2, "0").substring(0, 2) + '/' + (this.toDateRequest.getDate().toString().padStart(2, "0")).substring(0, 2) + '/' + this.toDateRequest.getFullYear()
    let fromCardString = '';
    let toCardString = '';
    let stationString = ''

    if (this.fromCard != -1) {
      fromCardString = this.fromCard.toString();
    }


    if (this.toCard != -1) {
      toCardString = this.toCard.toString();
    }
    if (this.selectedStation != -1) {
      stationString = this.selectedStation.toString();
    }

    if (id == "1") {


      if (this.folioFactura != '') {
        url = this.reporterURL + 'Excel/MonederoXiga.aspx?rptName=consumption&clientId=' + this.data.Client_id + '&invoice=' + this.folioFactura
      }
      else {
        url = this.reporterURL + 'Excel/MonederoXiga.aspx?rptName=consumption&clientId=' + this.data.Client_id + '&fromDate=' + fromDateString + '&toDate=' + toDateString;
      }
      if (this.fromCard != -1) {
        url += '&FromCard=' + fromCardString
      } if (this.toCard != -1) {
        url += '&ToCard=' + toCardString;
      }

      if (this.selectedStation != -1) {
        url += '&station=' + this.selectedStation;
      }

    } else if (id == "2") {

      url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Consumptions&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&FromCard=' + fromCardString + '&ToCard=' + toCardString + '&station=' + stationString + '&clientNumber=' + this.data.Client_number + '&clientId=' + this.data.Client_id + '&fileName=rpt_Consumptions&invoice=' + this.folioFactura;
    }
    else if (id == "3") {

      url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Consumptions&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&FromCard=' + fromCardString + '&ToCard=' + toCardString + '&station=' + stationString + '&clientNumber=' + this.data.Client_number + '&clientId=' + this.data.Client_id + '&rptFormat=word&fileName=rpt_Consumptions&invoice=' + this.folioFactura;
    } else if (id == "4") {

      url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Consumptions&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&FromCard=' + fromCardString + '&ToCard=' + toCardString + '&station=' + stationString + '&clientNumber=' + this.data.Client_number + '&clientId=' + this.data.Client_id + '&fileName=rpt_ConsumptionByDepartment&invoice=' + this.folioFactura;
    }
    else if (id == "5") {

      url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Consumptions&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&FromCard=' + fromCardString + '&ToCard=' + toCardString + '&station=' + stationString + '&clientNumber=' + this.data.Client_number + '&clientId=' + this.data.Client_id + '&fileName=rpt_ConsumptionByDepartmentLineal&invoice=' + this.folioFactura;
    }
    else if (id == "6") {

      url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Consumptions&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&FromCard=' + fromCardString + '&ToCard=' + toCardString + '&station=' + stationString + '&clientNumber=' + this.data.Client_number + '&clientId=' + this.data.Client_id + '&fileName=rpt_ConsumptionByDepartment&rptFormat=word&invoice=' + this.folioFactura;
    }
    else if (id == "7") {

      url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_Consumptions&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&FromCard=' + fromCardString + '&ToCard=' + toCardString + '&station=' + stationString + '&clientNumber=' + this.data.Client_number + '&clientId=' + this.data.Client_id + '&fileName=rpt_ConsumptionByDepartmentLineal&rptFormat=word&invoice=' + this.folioFactura;
    }

    window.open(url, "_blank");

  }

  generateReportConsumptions() {

    let fromDateString = (this.fromDateRequest.getMonth() + 1).toString().padStart(2, "0").substring(0, 2) + '/' + (this.fromDateRequest.getDate().toString().padStart(2, "0")).substring(0, 2) + '/' + this.fromDateRequest.getFullYear()
    let toDateString = (this.toDateRequest.getMonth() + 1).toString().padStart(2, "0").substring(0, 2) + '/' + (this.toDateRequest.getDate().toString().padStart(2, "0")).substring(0, 2) + '/' + this.toDateRequest.getFullYear()

    let url = this.reporterURL + 'pdf/MonederoXiga.aspx?rptId=data&rptName=rpt_SignedTicketByDate&FromDate=' + fromDateString + '&ToDate=' + toDateString + '&dep=-1&FromCard=' + this.fromCard + '&ToCard=' + this.toCard + '&folio=-1&clientNumber=' + this.data.Client_number + '&clientId=' + this.data.Client_id + '&station=' + this.selectedStation + "&redcoData=" + this.redcoData + "&invoice=" + this.folioFactura;

    window.open(url, "_blank");
  }

  clickOutside(isOut: any) {
    if (isOut) {
      this.showModalContent = false;
    }
  }
}


